import { DateString, YearString } from '@/types/state/filter';
import { mixpanelTrack } from './asyncMixpanel';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from './events';
import { addMonths, toIsoDateStringUtcCalendar } from '../dateUtils';

const isSameMonth = (left: DateString, right: DateString) => left.substring(0, 7) == right.substring(0, 7)

export const handleMonthSelectTracking = (
  payoutDate: DateString,
  year: YearString,
  monthFormatter: Intl.DateTimeFormat
) => {
  if (!payoutDate || typeof payoutDate !== 'string') {
    console.warn('Invalid payout date provided to handleMonthSelect');
    return;
  }
  try {
    const todayString = toIsoDateStringUtcCalendar(new Date());
    const lastMonth = addMonths(todayString , -1);

    const monthString = monthFormatter.format(new Date(payoutDate))
    const isLastMonthsPayout = isSameMonth(payoutDate, lastMonth);

    mixpanelTrack(MIXPANEL_EVENT.payouts.tableMonthRow.clicked, {
      widget: RevenueDashboardWidget.PayoutTable,
      page: 'payouts',
      month: monthString,
      year: year,
      isLastMonthsPayout: isLastMonthsPayout,
    });
  } catch (error) {
    console.error('Error in handleMonthSelect:', error);
    // Fallback tracking
    mixpanelTrack(MIXPANEL_EVENT.payouts.tableMonthRow.clicked, {
      widget: RevenueDashboardWidget.PayoutTable,
      page: 'payouts',
      month: 'Unknown',
      year: year,
      isLastMonthsPayout: false,
    });
  }
};
